import { render, staticRenderFns } from "./dock.vue?vue&type=template&id=fae2acfe"
import script from "./dock.js?vue&type=script&lang=js&external"
export * from "./dock.js?vue&type=script&lang=js&external"
import style0 from "./dock.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports